import React from "react"
import { Link } from "gatsby"

const Menu = () => (
  <div>
    <ul
      style={{
        listStyle: "none",
        display: "flex",
        justifyContent: "space-between",
        margin: `0 auto`,
        marginLeft: "15%",
        marginRight: "15%",
        marginBottom: "4%",
        maxWidth: "700px"
      }}
    >
      <li>
        <Link to="/"> Home </Link>
      </li>

      <li>
        <Link to="/blog"> Blogs  </Link>
      </li>

      <li>
        <Link to="/wiki"> Wiki </Link>
      </li>

      <li>
        <Link to="/about">  About  </Link>
      </li>
    </ul>

  </div>
)
export default Menu
